export default function Card({ children, className = '' }) {
    return (
        <div className={`bg-white rounded-2xl border border-slate-200/80 shadow-sm shadow-emerald-100/30 ${className}`}>
            {children}
        </div>
    );
}

export function CardBody({ children, className = '' }) {
    return <div className={`p-4 sm:p-6 ${className}`}>{children}</div>;
}
